<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn'

const isRouterAlive = ref(true)
const settingsStore = useSettingsStore()

provide('reload', reload)
function reload() {
  isRouterAlive.value = false
  nextTick(() => (isRouterAlive.value = true))
}

watch(() => settingsStore.title, () => {
  const title = settingsStore.title
  document.title = title ? `${'云端实验室(test)'}` : '云端实验室(test)'
}, {
  immediate: true,
})
</script>

<template>
  <el-config-provider :locale="zhCn">
    <RouterView v-if="isRouterAlive" />
  </el-config-provider>
</template>
